<template>
    <div style="width: 1000px;margin: 30px auto" id="authocyaninGene">
        <div style="margin: 10px auto 30px 50px; height: 20px">
            <div style="float: left">
                <a style="font-size: 20px;color:#407338"><b>Anthocyanin-related genes in <i>B. rapa</i><br/></b></a>
            </div>
            <div style="float: right; margin-right: 50px">
                <el-button style="width: 240px;font-weight: bold; font-size: 16px" @click="exportExcel">Export result as Excel</el-button>
            </div>
        </div>
        <div style="margin-top: 30px">
            <el-table
                id="AnthocyaninGeneShow"
                :data="AnthocyaninGene_list"
                height="580px"
                border
                header-cell-style="color:#407338;text-align:center"
                cell-style="color:#407338;text-align:center">
                <el-table-column
                    prop="atname"
                    label="At Name"
                    width="120px">
                </el-table-column>
                <el-table-column prop="atgene" label="At Gene" width="100px">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleAtGene(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.atgene}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="brname"
                    label="Br Name"
                    width="100px">
                </el-table-column>
                <el-table-column prop="brgene" label="Br Gene" width="100px">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleBraGene(scope.row)" style="color: #3742fa; background: inherit">{{scope.row.brgene}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="annotation"
                    label="Annotation"
                    width="300px">
                </el-table-column>
                <el-table-column
                    prop="reference"
                    label="Reference"
                    width="250px">
                </el-table-column>
            </el-table>
        </div>
        <div style="margin: 10px auto 10px 50px">
            <a style="color: #407338">"(s)" indicates BrABGs that exhibit synteny, and "T" indicates genes in the same tandem array as the above genes.</a>
            <br/>
            <br/>
            <a href="https://bmcgenomics.biomedcentral.com/articles/10.1186/1471-2164-15-426" target="_blank" style="color: #407338">
                Ning Guo, Feng Cheng, Jian Wu, Bo Liu, Shuning Zheng, Jianli Liang and Xiaowu Wang <i>Anthocyanin biosynthetic</i>
                genes in <i>Brassica rapa</i>, BMC Genomics 2014, 15:426.
            </a>
            <FunctionSelection v-if="boxtarget" :target="selection_gene"
                @hideBox="hideSelectionBox"
                @watchSubFunction="common.searchSubFunction"></FunctionSelection>
            <FucntionSelectionBra v-if="Bra_boxtarget" :target="selection_gene"
                @hideBox="hideBraSelectionBox"
                @watchSubFunctionBra="common.searchSubFunction"></FucntionSelectionBra>                   
            <FunctionSelectionAth10 v-if="Ath_boxtarget" :target="selection_gene"
                @hideBox="hideAth10SelectionBox"
                @watchSUbFunctionAth10="common.searchSubFunction"></FunctionSelectionAth10>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import FileSaver from 'file-saver';
    import XLSX from 'xlsx';
    import FunctionSelection from "../components/FunctionSelection";
    import FucntionSelectionBra from "../components/FucntionSelectionBra";
    import FunctionSelectionAth10 from "../components/FunctionSelectionAth10";
    export default {
        name: "AnthocyaninGene",
        data() {
            return {
                AnthocyaninGene_list: {},
                boxtarget: 0,
                Bra_boxtarget: 0,
                Ath_boxtarget: 0,
                selection_gene: '',
            }
        },
        components:{
            FunctionSelection,
            FucntionSelectionBra,
            FunctionSelectionAth10,
        },
        mounted() {
            this.judgeStyle();
            this.get_AnthocyaninGene_list()
        },
        methods: {
            judgeStyle() {
                document.getElementsByTagName('html')[0].style.height = '';
                document.getElementsByTagName('body')[0].style.height = '';
            },
            get_AnthocyaninGene_list() {
                axios({
                    url:'http://39.100.233.196:8001/api/get-anthocyanin-gene/',
                    type:'json',
                    method:'get',
                }).then((res)=>{
                    this.AnthocyaninGene_list = res.data
                    // console.log(this.AnthocyaninGene_list)
                })
            },
            handleAtGene(row) {
                // console.log(row.atgene)
                this.selection_gene = row.atgene
                if (this.selection_gene != '-') {
                    this.Ath_boxtarget = 1;
                    this.Bra_boxtarget = 0;
                }
            },
            handleBraGene(row) {
                // console.log(row.brgene.split(' ')[0])
                this.selection_gene = row.brgene.split(' ')[0]
                if (this.selection_gene != '-') {
                    this.Bra_boxtarget = 1;
                    this.Ath_boxtarget = 0;
                }
            },
            hideSelectionBox() {
                this.Bra_boxtarget = 0;
            },
            hideAth10SelectionBox () {
                this.Ath_boxtarget = 0;
            },
            searchGeneSeq (geneID) {
                // console.log(geneID)
                let routeUrl = this.$router.resolve({
                    path: "../GeneSequence/",
                    query: {Gene: geneID}
                });
                window.open(routeUrl.href, '_blank');
            },
            exportExcel() {
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    wb = XLSX.utils.table_to_book(document.querySelector("#AnthocyaninGeneShow").removeChild(fix))
                    document.querySelector("#AnthocyaninGeneShow").appendChild(fix)
                } else {
                    wb = XLSX.utils.table_to_book(document.querySelector("#AnthocyaninGeneShow"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        "Anthocyanin_genes_in_B.rapa.xlsx"
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout);
                }
                return wbout;
            },
        },
    }
</script>

<style>

#authocyaninGene .el-button {
    background-color: #E1E1E1;
    color: #407338;
    border: #ADADAD;
    font-size: 12px;
}

#authocyaninGene .el-button:hover {
    background-color: #E5F1FB;
    color: black;
}

</style>